export default __webpack_public_path__ + "static/qrcover-3943e72cf6bb4fe685c5917ea1d1cac4.jpg";